import { Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { hideModal } from '../../../store/actions/modalActions'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useTypedSelector } from '../../../hooks/useTypedSelector'
import {
    DragDropContext,
    Draggable,
    DraggableProvided,
    Droppable,
} from 'react-beautiful-dnd'
import { ConfigurationsActionType } from '../../../types/configurations'
import { checkUnsavedChanges } from '../../../store/actions/configurationActions'
import React, { createRef, useState } from 'react'
import { throwInfoMessage } from '../../../utils/Errors'
import { RuleRow } from './RuleRow'

export const MoveRuleModal = () => {
    const dispatch = useAppDispatch()

    const {
        data: { rules, path, guid },
    } = useTypedSelector((store) => store.modal)

    const [ruleItems, setRuleItems] = useState([...rules])
    const rowRefs = ruleItems.map(() => createRef())

    const handleOnDragEnd = (result: any) => {
        if (!result.destination) return
        setRuleItems((prevItems: any[]) => {
            const [reorderedItem] = prevItems.splice(result.source.index, 1)
            prevItems.splice(result.destination.index, 0, reorderedItem)
            return [...prevItems]
        })
        throwInfoMessage(`Moved to position ${result.destination.index + 1}`)
    }

    const handleClose = () => {
        dispatch(hideModal())
    }

    const handleSave = () => {
        dispatch({
            type: ConfigurationsActionType.CONFIG_MODIFY,
            payload: { path, data: ruleItems },
        })
        dispatch(checkUnsavedChanges(guid))
        dispatch(hideModal())
    }

    return (
        <>
            <div className="bg-blur" />
            <Modal
                centered
                show={true}
                backdrop="static"
            >
                <Modal.Header>
                    <Modal.Title>
                        <FormattedMessage id="modals.moveRules.reorderRules" />
                    </Modal.Title>
                </Modal.Header>
                <div
                    id="body"
                    style={{
                        maxHeight: window.innerHeight - 250,
                        overflowY: 'auto',
                    }}
                >
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <Droppable
                            direction="vertical"
                            droppableId="rules-modal"
                        >
                            {(provided) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    {!!ruleItems.length &&
                                        ruleItems.map(
                                            (
                                                rule: Record<string, any>,
                                                i: number
                                            ) => (
                                                <Draggable
                                                    key={rule.element_id}
                                                    draggableId={
                                                        rule.element_id
                                                    }
                                                    index={i}
                                                >
                                                    {(
                                                        provided: DraggableProvided
                                                    ) => (
                                                        <RuleRow
                                                            ref={(el) => {
                                                                // @ts-ignore
                                                                rowRefs[i].current! = el
                                                                provided.innerRef(el)
                                                            }}
                                                            key={rule.element_id + 1}
                                                            rules={ruleItems}
                                                            rule={rule}
                                                            index={i}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        />
                                                    )}
                                                </Draggable>
                                            )
                                        )}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
                <Modal.Footer>
                    <button
                        onClick={handleClose}
                        className="ms-2 app-btn-main app-btn-cancel"
                        type="button"
                    >
                        <FormattedMessage id="cancel" />
                    </button>
                    <button
                        onClick={handleSave}
                        type="button"
                        className="app-btn-main app-btn-apply"
                    >
                        <FormattedMessage id="apply" />
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
